module.exports = __webpack_public_path__ + "img/credit_refused.152ebcd3.png";